import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";

@Directive({
  selector: "[numericDateInput]"
})
export class NumericDateInputDirective {
  @Input() isYear: boolean = false;
  @Output("custom-date-keyup") customDateKeyUp: EventEmitter<any> = new EventEmitter();

  constructor(el: ElementRef
    , private _coreLanguageService: CoreLanguageService
    , private _coreCOMService: CoreCOMService) {

  }

  @HostListener("keydown", ["$event"])
  public isNumberKey(event: any) {
    const me = this;
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 8) {
      event.currentTarget.value = "";
      event.preventDefault();
    } else if (charCode === 13) {
      if (event.currentTarget.id === "birthdateDD") {
        document.getElementById("birthdateMM").focus();
        (document.getElementById("birthdateMM") as HTMLInputElement).select();
      } else if (event.currentTarget.id === "birthdateMM") {
        document.getElementById("birthdateYYYY").focus();
        (document.getElementById("birthdateYYYY") as HTMLInputElement).select();
      } else {
        document.getElementById("birthdateYYYY").blur();
      }
      event.preventDefault();
    } else if (!((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105))) {
      event.preventDefault();
    } else {
      // do nothing
    }
  }

  @HostListener("keyup", ["$event"])
  public isNumberKeyMobilecheck(event: any): void {
    const me = this;
    let targetId: string = "";
    if (me._coreCOMService.environment.client.isMobile) {
      let regexp: RegExp;
      if (me.isYear) {
        regexp = /^\d{1,4}$/;
      } else {
        regexp = /^\d{1,2}$/;
      }
      if (!regexp.test(event.target.value)) {
        const selectionStart = event.target.selectionStart - 1;
        event.target.value = event.target.value.slice(0, event.target.selectionStart - 1) + event.target.value.slice(event.target.selectionStart);
        event.target.selectionStart = selectionStart;
        event.target.selectionEnd = selectionStart;
      }
    }
    if (event.currentTarget.id === "birthdateDD") {
      targetId = "birthdateDD";
      if (event.currentTarget.value.length === 2) {
        document.getElementById("birthdateMM").focus();
        (document.getElementById("birthdateMM") as HTMLInputElement).select();
      }
    } else if (event.currentTarget.id === "birthdateMM") {
      targetId = "birthdateMM";
      if (event.currentTarget.value.length === 2) {
        document.getElementById("birthdateYYYY").focus();
        (document.getElementById("birthdateYYYY") as HTMLInputElement).select();
      }
    } else {
      if (event.currentTarget.value.length === 4) {
        // to define validation. blur and focus again
        document.getElementById("birthdateYYYY").blur();
        document.getElementById("birthdateYYYY").focus();
      }
      targetId = "birthdateYYYY";
    }
    me.customDateKeyUp.emit({ value: event.target.value, id: targetId });
  }
}
